import "styles/Layout.css";

import Desktop from "./desktop";
import Mobile from "./mobile";
import React, { useEffect, useRef } from "react";
import useWindowSize from "../useWindowSize";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import mainSelectors from "modules/main/selectors";
import mainAction from "modules/main/actions";
import _get from "lodash/get";
import pageTitleList from "modules/utils/pageTitleList";

const MainLayout = ({ children, title }) => {
  const authAdproResult = useSelector((state) => mainSelectors.authAdproResult(state));
  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const windowSize = useWindowSize();
  const history = useHistory();
  const [t, i18n] = useTranslation();
  const dispatch = useDispatch();
  const lastPage = useRef();
  const loginAnalyticsSent = useRef(false);
  const extraPages = ["/setting", "/setting/fb", "/wizard", "/no-connected-ads"];
  const titleAndSubTitle = pageTitleList.getPageTitleList(t);
  const titleName = titleAndSubTitle[history.location.pathname]
    ? titleAndSubTitle[history.location.pathname].title
    : title;
  const subTitleName = titleAndSubTitle[history.location.pathname]
    ? titleAndSubTitle[history.location.pathname].subTitle || ""
    : "";

  useEffect(() => {
    const lang = _get(authAdproResult, ["data", "lang"]) || sessionStorage.getItem("lang") || "en";
    console.log("MainLayout", authAdproResult, lang);
    i18n.changeLanguage(lang);
  }, [authAdproResult, i18n]);

  console.log("lastPage", lastPage.current, authAdproResult, currentAd);

  useEffect(() => {
    console.log("LoadingSendAnalyticsLogin", loginAnalyticsSent.current, currentAd);
    if (!loginAnalyticsSent.current && Object.keys(currentAd).length) {
      dispatch(
        mainAction.SendAnalyticsLogin(
          currentAd.rmp_business_id,
          currentAd.ads_account_id,
          currentAd.account_name,
          currentAd.create_time,
        ),
      );
      loginAnalyticsSent.current = true;
    }
  }, [dispatch, loginAnalyticsSent, currentAd]);

  console.log("checklog", loginAnalyticsSent, currentAd);

  if (
    history.location.pathname &&
    history.location.pathname.length > 1 &&
    history.location.pathname !== lastPage.current &&
    authAdproResult.result === 0 &&
    loginAnalyticsSent.current
  ) {
    console.log("LoadingSendAnalyticsPage", loginAnalyticsSent.current, currentAd);
    lastPage.current = history.location.pathname;
    dispatch(
      mainAction.SendAnalyticsPageView(
        currentAd.rmp_business_id,
        currentAd.ads_account_id,
        currentAd.account_name,
        history.location.pathname.replace("/", ""),
      ),
    );
  }

  if (windowSize.width > 834)
    return (
      <Desktop title={titleName} subTitle={subTitleName} extraPage={extraPages.indexOf(history.location.pathname) >= 0}>
        {children}
      </Desktop>
    );
  else
    return (
      <Mobile title={titleName} subTitle={subTitleName} extraPage={extraPages.indexOf(history.location.pathname) >= 0}>
        {children}
      </Mobile>
    );
};

export default MainLayout;
